import qs from 'qs';
import { validationParams } from './validationParams';

export function decodeQueryStrings(x) {
	const params = validationParams(x);

	return decodeURIComponent(qs.stringify(params));
}
